export default __webpack_public_path__ + "static/media/down-arrow.d2c1d784.svg";